import {
  CoverageMetaList,
} from '@sky-distribution/gp-onboarding-generic-submission';
import { CoverageCodes } from '@sky-distribution/gp-onboarding-policy-service';
import { GroupCodes } from './coverages.type';

export const coveragesMeta: CoverageMetaList = {
  [CoverageCodes.FixedElements]: {
    displayOrder: 0,
    name: 'Mury i elementy stałe',
    description: 'razem z piwnicą',
    showToolbox: true,
    includesCodes: [
      GroupCodes.FireFixedElements,
      GroupCodes.FloodingFixedElements,
      GroupCodes.GroupBurglary,
      CoverageCodes.FixedElementsShortCircuit,
      CoverageCodes.FixedElementsFlood,
      GroupCodes.VandalismFixedElements,
    ],
  },
  [CoverageCodes.Equipment]: {
    displayOrder: 1,
    name: 'Wyposażenie',
    description: 'np. meble, RTV, AGD, PC, biżuteria',
    showToolbox: true,
    includesCodes: [
      GroupCodes.FireEquipment,
      GroupCodes.FloodingEquipment,
      GroupCodes.GroupBurglary,
      CoverageCodes.EquipmentShortCircuit,
      CoverageCodes.EquipmentFlood,
      GroupCodes.VandalismEquipment,
    ],
  },
  [CoverageCodes.FixedElementsFire]: {
    isHidden: true,
    triggeredBy: [CoverageCodes.FixedElements],
    icon: 'fire',
    name: 'Pożar',
  },
  [CoverageCodes.FixedElementsShortCircuit]: {
    isHidden: true,
    triggeredBy: [CoverageCodes.FixedElements, GroupCodes.GroupShortCircuit],
    icon: 'shortCircuit',
    name: 'Przepięcie',
  },
  [CoverageCodes.FixedElementsFlood]: {
    isHidden: true,
    triggeredBy: [CoverageCodes.FixedElements, GroupCodes.GroupFlood],
    icon: 'flood',
    name: 'Powódź',
  },
  [CoverageCodes.EquipmentFire]: {
    isHidden: true,
    triggeredBy: [CoverageCodes.Equipment],
    icon: 'fire',
    name: 'Pożar',
  },
  [CoverageCodes.EquipmentShortCircuit]: {
    isHidden: true,
    triggeredBy: [CoverageCodes.Equipment, GroupCodes.GroupShortCircuit],
    icon: 'shortCircuit',
    name: 'Przepięcie',
  },
  [CoverageCodes.EquipmentFlood]: {
    isHidden: true,
    triggeredBy: [CoverageCodes.Equipment, GroupCodes.GroupFlood],
    icon: 'flood',
    name: 'Powódź',
  },
  [CoverageCodes.SolidElementsBreakage]: {
    name: 'Stłuczenia i pęknięcia',
    description: 'np. szklane elementy, płytki',
  },
  [CoverageCodes.CivilLiabilityInsurance]: {
    name: 'OC w życiu prywatnym',
    description: 'np. jak zalejesz mieszkanie sąsiada',
  },
  [CoverageCodes.SpecialistSupport]: {
    name: 'Pomoc specjalistów',
    description: 'np. hydraulik, elektryk, ślusarz',
  },
  [CoverageCodes.EquipmentBurglary]: {
    isHidden: true,
    triggeredBy: [CoverageCodes.Equipment, GroupCodes.GroupBurglary],
  },
  [CoverageCodes.FixedElementsBurglary]: {
    isHidden: true,
    triggeredBy: [CoverageCodes.Equipment, GroupCodes.GroupBurglary],
  },
};
